import React, { useRef, useEffect } from 'react';
import paper from 'paper';

const Tremor = ({
  curveCount = 100,
  colors = ['blue'],
  texts = [
    {
      text: '',
      count: 3000,
      fontSize: 400,
    },
  ],
  content = {
    justification: 'center',
    fontSize: texts[0].fontSize,
  },
}) => {
  const canvasRef = useRef(null);
  const [state] = React.useState({
    counter: 0,
    textIndex: 0,
  });

  const setupCurves = () => {
    const curves = [];
    for (let i = 0; i < curveCount; i++) {
      const curve = new paper.Path();
      curve.strokeColor = colors[i % colors.length];
      curve.strokeWidth = 2;

      for (let j = 0; j < 100; j++) {
        curve.add(new paper.Point(j * 100, i * 20));
      }
      curves.push(curve);
    }
    return curves;
  };

  const setupText = () => {
    const displayText = new paper.PointText({
      point: [paper.view.size.width / 2, paper.view.size.height / 2],
      content: texts[state.textIndex].text,
      ...content,
    });

    displayText.fillColor = colors[0];
    return displayText;
  };

  const updateText = (displayText) => {
    if (state.textIndex < texts.length - 1) state.counter += 1;
    if (state.counter > texts[state.textIndex].count) {
      state.textIndex += 1;
      displayText.content = texts[state.textIndex].text;
      displayText.fontSize = texts[state.textIndex].fontSize;
    }
  };

  const onMouseMove = (event, curves, displayText) => {
    const mousePoint = event.point;

    curves.forEach((curve) => {
      curve.segments.forEach((segment) => {
        const distance = segment.point.getDistance(mousePoint);
        const bendFactor = -100 / (distance + 1);
        const direction = segment.point.subtract(mousePoint).normalize();
        const nature = Math.random() < 0.5;
        if (nature) {
          segment.point = segment.point.subtract(direction.multiply(bendFactor));
        } else {
          segment.point = segment.point.add(direction.multiply(bendFactor));
        }
      });
    });

    updateText(displayText);
  };

  useEffect(() => {
    paper.setup(canvasRef.current);

    const curves = setupCurves();
    const displayText = setupText();

    const handleMouseMove = (event) => {
      onMouseMove(event, curves, displayText);
    };

    paper.view.on('mousemove', handleMouseMove);

    return () => {
      paper.view.off('mousemove', handleMouseMove);
      paper.project.clear();
    };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />;
};

export default Tremor;
